import React from "react";
import * as S from "./style";
import TextProps from "../interface";

function BaseText({ ...etcProps }: TextProps): React.ReactElement {
  return <S.Text as={etcProps.as} {...etcProps} />;
}

export default BaseText;
